import { Outlet, useRouterState } from '@tanstack/react-router'
import { EmptyState } from '../design'
import { QueuePage } from '../features/queue/QueuePage'
import { SHELL_COPY } from './copy'
import { useWideWorkspace } from './useWideWorkspace'
import { WorkspacePanes } from './WorkspacePanes'

export const QUEUE_ROUTE_ID = '/'
export const ITEM_ROUTE_ID = '/items/$itemId'

type Place = 'queue' | 'item' | 'elsewhere'

type RouteMatch = { routeId: string; params: Record<string, string> }

const placeOf = (routeIds: readonly string[]): Place => {
  if (routeIds.includes(ITEM_ROUTE_ID)) return 'item'
  if (routeIds.includes(QUEUE_ROUTE_ID)) return 'queue'
  return 'elsewhere'
}

const openItemIdOf = (matches: readonly RouteMatch[]): string | undefined =>
  matches.find((match) => match.routeId === ITEM_ROUTE_ID)?.params['itemId']

export const QueueWorkspace = () => {
  const wide = useWideWorkspace()
  const place = useRouterState({ select: (state) => placeOf(state.matches.map((match) => match.routeId)) })
  const openItemId = useRouterState({ select: (state) => openItemIdOf(state.matches) })

  if (!wide || place === 'elsewhere') return <Outlet />

  return (
    <WorkspacePanes
      list={<QueuePage {...(openItemId === undefined ? {} : { currentItemId: openItemId })} />}
      listLabel={SHELL_COPY.queue}
      main={place === 'item' ? <Outlet /> : <EmptyState title={SHELL_COPY.pickItemTitle} description={SHELL_COPY.pickItemBody} />}
    />
  )
}
